import type { ComponentContentSchema } from '@vibesites/runtime';
import { EditableToken, useContentToken } from '@vibesites/runtime/react';
import { ArrowRight } from 'lucide-react';
import pagesData from '../pages.json';

interface PageEntry {
  name: string;
  path: string;
  position: number;
  visible?: boolean;
  noindex?: boolean;
  template?: string;
}

/** Link list of every visible, indexable page. */
export function SitemapContent() {
  const heading = useContentToken('sitemapcontent.heading');
  const pages = Object.values(pagesData as Record<string, PageEntry>)
    .filter((p) => p.visible !== false && !p.noindex && !p.template)
    .sort((a, b) => a.position - b.position);

  return (
    <section className="bg-background pb-16 pt-4 md:pb-24">
      <div className="mx-auto max-w-[860px] px-6">
        <EditableToken path="sitemapcontent.heading" as="h2" className="js-reveal js-heading text-[24px] text-secondary">
          {heading}
        </EditableToken>
        <ul className="js-stagger js-d1 mt-6 grid gap-x-10 border-t border-border sm:grid-cols-2">
          {pages.map((p) => (
            <li key={p.path} className="border-b border-border">
              <a href={p.path} className="group flex items-center justify-between py-4 font-body text-[18px] font-medium text-foreground no-underline transition-[color,padding] duration-300 ease-out hover:pl-2 hover:text-primary">
                {p.name}
                <ArrowRight className="h-4 w-4 text-primary transition-transform duration-[250ms] group-hover:translate-x-1" aria-hidden />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SitemapContent',
  displayName: 'Sitemap',
  tokens: {
    'sitemapcontent.heading': { label: 'Heading', type: 'text', defaultValue: 'All Pages' },
  },
};

(SitemapContent as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SitemapContent;
